import { defineMessages } from "react-intl";

export const leftOperatorsMessages = defineMessages({
  Price: {
    id: "b1zuN9",
    defaultMessage: "Price",
  },
  Category: {
    id: "ccXLVi",
    defaultMessage: "Category",
  },
  Channel: {
    id: "KeO51o",
    defaultMessage: "Channel",
  },
  Collection: {
    id: "phAZoj",
    defaultMessage: "Collection",
  },
  ProductType: {
    id: "da1ebU",
    defaultMessage: "Product type",
  },
  IsAvailable: {
    id: "9MGrEp",
    defaultMessage: "Is available",
  },
  IsPublished: {
    id: "mIRBuW",
    defaultMessage: "Is published",
  },
  VisibleInListing: {
    id: "QqnNUm",
    defaultMessage: "Visible in listing",
  },
  HasCategory: {
    id: "QHDtwH",
    defaultMessage: "Has category",
  },
  IsGiftcard: {
    id: "Eq3GFh",
    defaultMessage: "Is giftcard",
  },
});
